<template>
  <section class="bg-light mb-4 mb-lg-5">
    <div class="container text-center py-3 py-lg-5">
      <nav aria-label="breadcrumb">
        <slot name="breadcrumb"></slot>
      </nav>
    </div>
  </section>
</template>
